module.exports = {"profile":{"educations":{"headline":"Education","emptyText":"Share your educational background."}}}